<template>
  <div class="access-log-page">
    <div class="toolbar">
      <el-input v-model="filterUrl" placeholder="搜索URL" class="search" clearable />
      <el-input-number v-model="filterUserId" placeholder="用户ID" :min="0" controls-position="right" class="search-num" />
      <el-button type="primary" @click="loadList">搜索</el-button>
      <el-button type="danger" @click="batchDelete" :disabled="!selectedIds.length">批量删除 ({{ selectedIds.length }})</el-button>
    </div>
    <el-table :data="list" style="width:100%" stripe @selection-change="onSelectionChange">
      <el-table-column type="selection" width="45" />
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="user_id" label="用户ID" width="80" />
      <el-table-column prop="url" label="URL" min-width="300" show-overflow-tooltip />
      <el-table-column prop="method" label="方法" width="70" />
      <el-table-column prop="ip" label="IP" width="130" />
      <el-table-column prop="user_agent" label="UA" min-width="200" show-overflow-tooltip />
      <el-table-column prop="created_at" label="访问时间" width="160">
        <template #default="{ row }">
          <span>{{ row.created_at ? new Date(row.created_at * 1000).toLocaleString() : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template #default="{row}">
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"/>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '../../utils/request';

const list = ref([]);
const pagination = ref({ page: 1, pageSize: 20, total: 0 });
const filterUrl = ref('');
const filterUserId = ref(0);
const selectedIds = ref([]);

const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize };
  if (filterUrl.value) params.url = filterUrl.value;
  if (filterUserId.value > 0) params.user_id = filterUserId.value;
  try {
    const data = await request.get('/v1/access-log/list', { params });
    list.value = data.list;
    pagination.value.total = data.pagination.total;
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

const pageChange = (p) => {
  pagination.value.page = p;
  loadList();
};

const onSelectionChange = (rows) => {
  selectedIds.value = rows.map(r => r.id);
};

const remove = async (row) => {
  try {
    await ElMessageBox.confirm('确定删除此记录？', '提示', { type: 'warning' });
    await request.post('/v1/access-log/delete', { id: row.id });
    ElMessage.success('删除成功');
    loadList();
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e.toString());
  }
};

const batchDelete = async () => {
  try {
    await ElMessageBox.confirm(`确定删除选中的 ${selectedIds.value.length} 条记录？`, '提示', { type: 'warning' });
    await request.post('/v1/access-log/batch-delete', { ids: selectedIds.value });
    ElMessage.success('批量删除成功');
    selectedIds.value = [];
    loadList();
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e.toString());
  }
};

onMounted(loadList);
</script>

<style scoped>
.access-log-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.search { width: 200px; }
.search-num { width: 120px; }
.pager { margin-top: 15px; text-align: right; }
</style>
